Ext.define('SA.view.plugin.CloseOnClickOutside', {
    alias: 'plugin.close-on-click-outside',
    extend: 'Ext.AbstractPlugin',
    pluginId: 'close-on-click-outside',

    init() {
        this.cmp.on({
            hide: this.onComponentHide,
            show: this.onComponentShow,

            scope: this
        });
    },

    destroy() {
        this.onComponentHide();
    },

    getSafeElements() {
        var cmp = this.cmp,
            els = [],
            WindowManager = Ext.WindowManager;

        pushEl(cmp);

        WindowManager.eachTopDown(win => {
            if (win === cmp) {
                return false;
            }

            if (!cmp.isDescendantOf(win)) {
                pushEl(win);

                if (win.modal) {
                    pushEl(WindowManager.mask);
                }
            }
        });

        return els;

        function pushEl(el) {
            if (el instanceof Ext.Component) {
                el = el.el;
            }

            if (el && el.dom) {
                el = el.dom;
            }

            if (el) {
                els.push(el);
            }
        }
    },

    hideComponent() {
        this.cmp.hide();
    },

    onComponentHide() {
        Ext.getDoc().un('mousedown', this.onDocMouseDown, this);
    },

    onComponentShow() {
        Ext.getDoc().on('mousedown', this.onDocMouseDown, this);
    },

    onDocMouseDown(ev, el) {
        var safeEls = this.getSafeElements(),
            allowHide = this.cmp.fireEvent('mousedown:outside', el);

        if (!allowHide) {
            return;
        }

        for ( ; el ; el = el.parentNode) {
            if (safeEls.includes(el)) {
                return;
            }
        }

        this.hideComponent();
    }
});